import type { CollectionRouting } from '../types/schedule.types';

export type CollectionRoutingAxis = 'deposit' | 'full_payment' | null;

// The ONE reader for "dealer-collected, and on which axis". Both axes reading 'dealer'
// is malformed; deposit wins deterministically rather than throwing.
export const dealerCollectedAxis = (routing: CollectionRouting | undefined): CollectionRoutingAxis => {
    if (routing?.depositCollection === 'dealer') {
        return 'deposit';
    }
    if (routing?.fullPaymentCollection === 'dealer') {
        return 'full_payment';
    }
    return null;
};
